const inputRegex = RegExp(`^\\d*(?:\\\\[.])?\\d*$`) // match escaped "." characters via in a non-capturing group
const escapeRegExp = (string: string): string => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // $& means the whole matched string

export const formatInputValue = (value: string, decimals: number): string => {
  let nextUserInput = value.replace(/,/g, '.')
  const previousValue = value.length > 0 && nextUserInput.slice(0, nextUserInput.length - 1)

  const lastIndex = nextUserInput.lastIndexOf('.')

  if (lastIndex > 0) {
    nextUserInput = nextUserInput.slice(0, lastIndex + 1 + decimals) //18=decimals
  } else {
    nextUserInput = nextUserInput.slice(0, 15) //max length of a value that is not starting with 0.0
  }
  if (nextUserInput === '' || inputRegex.test(escapeRegExp(nextUserInput))) {
    return nextUserInput
  }
  if (nextUserInput === '.') {
    return '0.'
  }
  if (
    inputRegex.test(escapeRegExp(nextUserInput)) &&
    nextUserInput.length > 1 &&
    nextUserInput[0] === '0' &&
    nextUserInput[1] !== '.'
  ) {
    const newInput = nextUserInput[0] + '.' + nextUserInput.slice(1)
    if (inputRegex.test(escapeRegExp(newInput))) {
      return newInput
    }
    return ''
  } else if (previousValue && inputRegex.test(escapeRegExp(previousValue))) {
    return previousValue
  }

  return ''
}
// TODO: if null===> don't set
